import React from 'react';
import Breadcrumb from '../components/Common/Breadcrumb';
import { Link } from 'react-router-dom';

const Countries = () => {
  const countries = [
    {
      id: 1,
      name: 'United States',
      image: '/assets/img/usa.jpg',
      description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.'
    },
    {
      id: 2,
      name: 'Canada',
      image: '/assets/img/country-1.jpg',
      description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.'
    },
    {
      id: 3,
      name: 'Australia',
      image: '/assets/img/country-2.jpg',
      description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.'
    },
    {
      id: 4,
      name: 'United Kingdom',
      image: '/assets/img/country-3.jpg',
      description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.'
    },
    {
      id: 5,
      name: 'Germany',
      image: '/assets/img/country-4.jpg',
      description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.'
    },
    {
      id: 6,
      name: 'Italy',
      image: '/assets/img/italy.jpg',
      description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.'
    }
  ];

  return (
    <>
      <Breadcrumb title="Countries" />
      <div className="container-fluid py-5">
        <div className="container py-5">
          <div className="section-title text-center mb-5 wow fadeInUp" data-wow-delay="0.1s">
            <div className="sub-style">
              <h5 className="sub-title text-primary px-3">Popular Countries</h5>
            </div>
            <h1 className="display-5 mb-4">Explore Immigration Opportunities</h1>
            <p className="mb-0">Lorem ipsum dolor sit amet consectetur adipisicing elit. Quaerat deleniti amet at atque sequi quibusdam cumque itaque repudiandae temporibus.</p>
          </div>
          <div className="row g-4">
            {countries.map((country, index) => (
              <div key={country.id} className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay={`${0.1 + index * 0.2}s`}>
                <div className="country-item text-center">
                  <div className="country-img mb-4">
                    <img src={country.image} className="img-fluid rounded" alt={country.name} />
                  </div>
                  <div className="country-content">
                    <h5 className="mb-3">{country.name}</h5>
                    <p className="mb-4">{country.description}</p>
                    <Link className="btn btn-primary rounded-pill" to={`/country/${country.id}`}>Learn More</Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default Countries; 